import { type ActionItem } from 'shared/ui'
import { type Campaign } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { campaignDetailsAction } from 'widgets/CampaignDetailsModal'
import { editCampaign } from 'pages/campaigns/actions/actionItems/editCampaign'
import { duplicateCampaign } from 'pages/campaigns/actions/actionItems/duplicateCampaign'
import { deleteCampaign } from 'pages/campaigns/actions/actionItems/deleteCampaign'
import { toggleActiveCampaign } from 'pages/campaigns/actions/actionItems/toggleActiveCampaign'

export const getCampaignActions = (
  campaign: Campaign,
  onSuccessDelete: () => void,
  entities: IEntitiesStore
): ActionItem[] => {
  const toggleActive = toggleActiveCampaign(campaign)
  const editAction = editCampaign(campaign)
  const duplicateAction = duplicateCampaign(campaign, entities)
  const deleteAction = deleteCampaign(campaign, onSuccessDelete)
  const detailsAction = campaignDetailsAction(campaign)

  if (campaign.status === 'active' || campaign.status === 'disabled') {
    return [toggleActive, editAction, detailsAction, duplicateAction, deleteAction]
  }
  if (campaign.status === 'draft') {
    return [editAction, detailsAction, duplicateAction, deleteAction]
  }
  return []
}
